import { Controller } from "@hotwired/stimulus"

// フォーム内の行をドラッグ&ドロップで並べ替え、position hidden field を更新する
export default class extends Controller {
  static targets = ["row"]

  connect() {
    this.draggedRow = null

    this.rowTargets.forEach(row => {
      row.setAttribute("draggable", "true")
      row.addEventListener("dragstart", this.onDragStart)
      row.addEventListener("dragover", this.onDragOver)
      row.addEventListener("drop", this.onDrop)
      row.addEventListener("dragend", this.onDragEnd)
    })
  }

  onDragStart = (event) => {
    this.draggedRow = event.currentTarget
    event.currentTarget.classList.add("opacity-50")
    event.dataTransfer.effectAllowed = "move"
  }

  onDragOver = (event) => {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const target = event.currentTarget
    if (target === this.draggedRow) return

    const rect = target.getBoundingClientRect()
    const midY = rect.top + rect.height / 2

    if (event.clientY < midY) {
      target.parentNode.insertBefore(this.draggedRow, target)
    } else {
      target.parentNode.insertBefore(this.draggedRow, target.nextSibling)
    }
  }

  onDrop = (event) => {
    event.preventDefault()
  }

  onDragEnd = () => {
    if (this.draggedRow) {
      this.draggedRow.classList.remove("opacity-50")
    }
    this.draggedRow = null
    this.updatePositions()
  }

  updatePositions() {
    this.rowTargets.forEach((row, index) => {
      const positionInput = row.querySelector("input[data-position]")
      if (positionInput) {
        positionInput.value = index
      }
    })
  }
}
